import React from "react";
import _ from "lodash";
import { Page, Text, View, Image } from "@react-pdf/renderer";

import { ADDRESS_TYPES } from "../../../constants/constants";
import CDK_Logo from "../../../images/CDKGlobalWM_BLK.jpg";
import commonStyles from "../PDFStyles/common";
import styles from "../PDFStyles/FormF";
import { getAddressDetails } from "../../../util/candidateDataFilters";
import {
  getAddressAsString,
  getFormattedDate,
  getFullName,
  getGenderName,
  getMaritalName
} from "../../../util/helpers";
import {
  getDeclarationPlace,
  getNomineeData,
  getRelationShipName,
  getStateName
} from "../../../util/onBoardingDataFilters";

const FormF = React.memo(
  ({
    candidateDetails,
    states,
    maritalStatusList,
    genders,
    relationShipList
  }) => {
    const {
      addresses,
      dateofJoining,
      declarationDate,
      declarationPlace,
      familyMembers = [],
      gender,
      gratuityNomination,
      maritalStatus,
      religion
    } = candidateDetails;

    const candidateFullName = getFullName(candidateDetails);

    const { thana, city, subDivision, postOffice, district, state } =
      getAddressDetails("permanent", addresses);

    const gratuityNomineeIds = _.map(gratuityNomination, "familyMemberId");

    const getGratuityNominees = (isSelected = true) => {
      return isSelected
        ? familyMembers.filter(member => gratuityNomineeIds.includes(member.id))
        : familyMembers.filter(
            member => !gratuityNomineeIds.includes(member.id)
          );
    };

    return (
      <Page size="A4" style={commonStyles.page}>
        <Image style={commonStyles.cdkLogo} src={CDK_Logo} />
        <View style={commonStyles.header}>
          <Text style={commonStyles.headerTitleWithUnderline}>FORM ‘F’</Text>
          <Text>(See sub-rule (1) of Rule 6)</Text>
        </View>

        <Text>To,</Text>

        <View style={styles.formFDetails}>
          <Text>CDK Global</Text>
          <Text>
            {"I, Shri / Shrimati / Kumari "}
            <Text
              style={{
                ...commonStyles.textUnderline,
                ...commonStyles.fontBold
              }}
            >
              {candidateFullName}
            </Text>
            {" ( name in full here )"} whose particulars are given in the
            statement below, hereby nominate the person(s) mentioned below to
            receive the gratuity payable after my death as also the gratuity
            standing to my credit in the event of my death before the amount as
            become payable, has not been paid and direct that the said amount of
            gratuity shall be paid in proportion indicated against the name(s)
            of the nominee(s).
          </Text>

          <Text>
            2. I hereby certify that the person(s) mentioned is a /are member(s)
            of my family within the meaning of clause (h) of section 2 of the
            payment of gratuity Act, 1972.
          </Text>

          <Text>
            3. I hereby declare that I have no family within the meaning of
            clause (h) of Section 2 of the said Act.
          </Text>

          <View>
            <Text>
              4. (a) My father / mother parents is/are not dependent on me.
            </Text>
            <Text style={styles.dependantPoint}>
              (b) My husband’s father / mother / parents is/are not dependent on
              my husband.
            </Text>
          </View>

          <Text>
            5. I have excluded my husband from my family by a notice dated the
            ………………… to the Controlling Authority in terms of the provison to
            clause (h) of section 2 of the said Act.
          </Text>

          <Text>
            6. Nomination made herein invalidates my previous nomination.
          </Text>
        </View>

        <View style={commonStyles.table}>
          <View style={{ ...commonStyles.tableRow, ...commonStyles.fontBold }}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>Sl.No</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.nameAndAddressCol }}
            >
              <Text style={commonStyles.tableCell}>
                Name in full with full address of nominee(s)
              </Text>
            </View>
            <View
              style={{
                ...commonStyles.tableCol,
                ...styles.relationShipCol,
                ...commonStyles.textCenter
              }}
            >
              <Text style={commonStyles.tableCell}>
                Relation with the employee
              </Text>
            </View>
            <View
              style={{
                ...commonStyles.tableCol,
                ...styles.ageOfNomineeCol,
                ...commonStyles.textCenter
              }}
            >
              <Text style={commonStyles.tableCell}>Age of the Nominee</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...commonStyles.textCenter }}
            >
              <Text style={commonStyles.tableCell}>
                Proportion by which the gratuity will be shared
              </Text>
            </View>
          </View>
          {getGratuityNominees().map((nomination, index) => (
            <View style={commonStyles.tableRow}>
              <View
                style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
              >
                <Text style={commonStyles.tableCell}>{index + 1}</Text>
              </View>
              <View
                style={{
                  ...commonStyles.tableCol,
                  ...styles.nameAndAddressCol
                }}
              >
                <Text style={commonStyles.tableCell}>
                  {nomination.fullName}
                </Text>
              </View>
              <View
                style={{ ...commonStyles.tableCol, ...styles.relationShipCol }}
              >
                <Text style={commonStyles.tableCell}>
                  {getRelationShipName(
                    nomination.relationShipType,
                    relationShipList
                  )}
                </Text>
              </View>
              <View
                style={{ ...commonStyles.tableCol, ...styles.ageOfNomineeCol }}
              >
                <Text style={{ ...commonStyles.tableCell }}>
                  {nomination.age}
                </Text>
              </View>
              <View style={commonStyles.tableCol}>
                <Text style={commonStyles.tableCell}>
                  {getNomineeData(
                    gratuityNomination,
                    "gratuityProprotionShared",
                    nomination.id
                  )}
                </Text>
              </View>
            </View>
          ))}
        </View>

        <View style={{ ...commonStyles.table, ...commonStyles.marginTop20 }}>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>1</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>
                Name of the employee in full
              </Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>{candidateFullName}</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>2</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>Sex</Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>
                {getGenderName(gender, genders)}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>3</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>Religion</Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>{religion}</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>4</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>
                {"Whether unmarried/ married/ widow/ widower"}
              </Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>
                {getMaritalName(maritalStatus, maritalStatusList, true)}
              </Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>5</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>
                Department /Branch / Section Where employed
              </Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>CDK Global</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>6</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>
                Post held with Ticket or serial No.if any
              </Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}> </Text>
            </View>
          </View>
          <View style={{ ...commonStyles.tableRow, marginBottom: 0 }}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>7</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>Date of Appointment</Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>
                {getFormattedDate(dateofJoining)}
              </Text>
            </View>
          </View>
        </View>

        <Image break style={commonStyles.cdkLogo} src={CDK_Logo} />

        <View style={commonStyles.table}>
          <View style={commonStyles.tableRow}>
            <View
              style={{ ...commonStyles.tableCol, ...styles.serialNumberCol }}
            >
              <Text style={commonStyles.tableCell}>8</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.detailsKeyColumn }}
            >
              <Text style={commonStyles.tableCell}>Permanent Address</Text>
            </View>
            <View style={{ ...commonStyles.tableCol, ...commonStyles.width60 }}>
              <Text style={commonStyles.tableCell}>
                {getAddressAsString(ADDRESS_TYPES.PERMANENT, addresses, states)}
              </Text>
            </View>
          </View>
        </View>

        <View style={{ ...commonStyles.table, ...commonStyles.marginTop20 }}>
          <View style={{ ...commonStyles.tableRow, ...commonStyles.textLeft }}>
            <View
              style={{
                ...commonStyles.tableCol,
                ...styles.villageOrPostOffice
              }}
            >
              <Text style={commonStyles.tableCell}>Village</Text>
            </View>
            <View style={commonStyles.tableCol}>
              <Text style={commonStyles.tableCell}>{city}</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.thanaOrDistrict }}
            >
              <Text style={commonStyles.tableCell}>Thana</Text>
            </View>
            <View
              style={{
                ...commonStyles.tableCol,
                ...styles.thanaOrDistrictValue
              }}
            >
              <Text style={commonStyles.tableCell}>{thana}</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.subDivisionOrState }}
            >
              <Text style={commonStyles.tableCell}>Sub-Division</Text>
            </View>
            <View style={commonStyles.tableCol}>
              <Text style={commonStyles.tableCell}>{subDivision}</Text>
            </View>
          </View>
          <View style={commonStyles.tableRow}>
            <View
              style={{
                ...commonStyles.tableCol,
                ...styles.villageOrPostOffice
              }}
            >
              <Text style={commonStyles.tableCell}>Post Office</Text>
            </View>
            <View style={commonStyles.tableCol}>
              <Text style={commonStyles.tableCell}>{postOffice}</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.thanaOrDistrict }}
            >
              <Text style={commonStyles.tableCell}>District</Text>
            </View>
            <View
              style={{
                ...commonStyles.tableCol,
                ...styles.thanaOrDistrictValue
              }}
            >
              <Text style={commonStyles.tableCell}>{district}</Text>
            </View>
            <View
              style={{ ...commonStyles.tableCol, ...styles.subDivisionOrState }}
            >
              <Text style={commonStyles.tableCell}>State</Text>
            </View>
            <View style={commonStyles.tableCol}>
              <Text style={commonStyles.tableCell}>
                {getStateName(state, states)}
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{
            ...commonStyles.flexRowSpaceBetween,
            ...commonStyles.textRed
          }}
        >
          <View style={commonStyles.declarationPlaceDateStyles}>
            <Text>
              {"Place: "}
              <Text style={commonStyles.textBlack}>
                {getDeclarationPlace(declarationPlace)}
              </Text>
            </Text>
            <Text>
              {"Date: "}
              <Text style={commonStyles.textBlack}>
                {getFormattedDate(declarationDate)}
              </Text>
            </Text>
          </View>
          <View style={commonStyles.declarationSignature}>
            <Text style={commonStyles.textBlack}>{candidateFullName}</Text>
            <Text>Signature / Thumb – Impression Of the employee</Text>
          </View>
        </View>

        <View
          style={{
            ...commonStyles.horizontalLine,
            ...styles.hrLineNearWitnessDeclaration
          }}
        />

        <View>
          <Text
            style={{ ...commonStyles.fontBold, ...commonStyles.autoMargin }}
          >
            Declaration by witnesses
          </Text>
          <View style={styles.signedNomination}>
            <View style={styles.nominationDetails}>
              <Text>Nomination signed / thumb-impression beforeme.</Text>
              <Text>Name in full and full Address of witness</Text>
            </View>
            <Text style={styles.witnessSignature}>Signature of witness</Text>
            <View style={commonStyles.flexRowSpaceBetween}>
              <View
                style={{
                  ...commonStyles.flexColumnFlexStart,
                  ...commonStyles.width50
                }}
              >
                <Text>1. </Text>
                <Text>2. </Text>
              </View>
              <View
                style={{
                  ...commonStyles.flexColumnFlexStart,
                  ...commonStyles.width50
                }}
              >
                <Text>1. </Text>
                <Text>2. </Text>
              </View>
            </View>
          </View>
          <View
            style={{
              ...commonStyles.flexColumnFlexStart,
              ...commonStyles.marginTop20,
              lineHeight: 2
            }}
          >
            <Text>Place </Text>
            <Text>Date </Text>
          </View>
        </View>

        <View
          style={{
            ...commonStyles.horizontalLine,
            ...styles.hrLineNearEmployerCertify
          }}
        />

        <View style={styles.employerCertify}>
          <Text style={styles.certifyByEmployer}>Certify by the Employer</Text>
          <Text>
            Certified that the particulars of the above nomination have been
            verified and recorded in this establishment.
          </Text>
          <Text>Employer’s reference No., if any</Text>
        </View>

        <View
          style={{
            ...commonStyles.flexRowSpaceBetween,
            ...commonStyles.marginTop20,
            lineHeight: 2
          }}
        >
          <View>
            <Text>Date </Text>
          </View>
          <View
            style={{
              ...commonStyles.flexColumnFlexStart,
              ...commonStyles.width50,
              ...styles.employerSignature
            }}
          >
            <Text>Signature of the Employer/ Officer</Text>
            <Text style={commonStyles.marginRight90}>
              Authorized Designation
            </Text>
            <Text style={styles.nameAndEstablishmentAddress}>
              Name and Address of the establishment or Rubber stamp thereof
            </Text>
          </View>
        </View>
      </Page>
    );
  }
);

export default FormF;
